<template>
   <span>
      <v-img
          :src="innerSrc"
          @click="dialog = true"
          max-height="90"
          max-width="90"
          v-if="showImage && !avatar"
      />
       <v-avatar
           @click="dialog = true"
           v-if="showImage && avatar"
       >
           <img :src="innerSrc" height="90" width="90"/>
       </v-avatar>
      <v-tooltip bottom v-if="!showImage">
         <template v-slot:activator="{ on }">
           <v-icon @click="openDocument" color="primary" dark v-on="on">{{getDocumentImage}}</v-icon>
         </template>
         <span>{{file_name}} file</span>
      </v-tooltip>
    <v-dialog v-model="dialog" width="800">
      <img :src="innerSrc">
    </v-dialog>
   </span>
</template>

<script>
    export default {
        name: "FileDisplay",
        props: {
            src: {
                type: [String, File]
            },
            avatar: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                dialog: false,
                extension: "",
                openInTab: true,
                innerSrc: null,
                file_name: '',
            }
        },
        methods: {
            openDocument() {
                if (this.openInTab)
                    window.open(this.src, '_blank')
            }
        },
        computed: {
            getDocumentImage() {
                let fileImage = "description";
                switch (this.extension.toLowerCase()) {
                    case "docx":
                        fileImage = "mdi-file-word-box";
                        break;
                    case "pdf":
                        fileImage = "mdi-file-pdf";
                        break;
                    case "xlsx":
                        fileImage = "mdi-file-excel-box";
                        break;
                    case "xls":
                        fileImage = "mdi-file-excel-box";
                        break;
                }
                return fileImage;
            },

            showImage() {
                return (this.extension === 'png' || this.extension === 'jpeg' || this.extension === 'jpg');
            }
        },
        mounted() {
            if (this.src instanceof File) {
                this.openInTab = false;
                const fileReader = new FileReader();
                fileReader.readAsDataURL(this.src);
                fileReader.addEventListener('load', () => {
                    this.innerSrc = fileReader.result;
                });

                let extension = this.src.name.split('.').pop();
                this.extension = extension.toLowerCase();
                this.file_name = this.src.name;
            } else {
                this.innerSrc = this.src;
                if (this.src !== undefined) {
                    let extension = this.src.split('.').pop();
                    extension = extension.split('?').shift();
                    this.extension = extension.toLowerCase();
                }

            }
        }
    }
</script>
